import styled from "styled-components";

import { fonts, colors } from "../../styles/variables";
import breakpoints from "../../styles/breakpoints";

export const StyledContainer = styled.div<{ height?: number }>`
  margin: 0;
  padding: 50px 0px;
  text-align: center;
  ${breakpoints.smDown} {
    padding: 10px;
  }
  background-color: ${colors.peachTint};
  min-width: 100%;
  overflow-x: hidden;
  min-height: ${(props) => (props.height ? `${props.height}px` : "100%")};
  flex-direction: column;
  flex: 1;
`;

export const StyledImg = styled.img`
  max-width: 500px;
  padding: 20px 10px;
  ${breakpoints.smDown} {
    max-width: 100%;
  }
`;

export const StyledText = styled.h5`
  font-size: 28px;
  line-height: 30px;
  ${breakpoints.smDown} {
    font-size: 24px;
    line-height: 26px;
  }
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
`;

export const StyledParagraph = styled.p`
  font-family: ${fonts.fontBauMedium};
  font-size: 16px;
  max-width: 60%;
  margin: auto;
  ${breakpoints.smDown} {
    max-width: 100%;
  }
`;

export const StyledHeaderLogoImage = styled.img`
  max-width: 200px;
  width: 100%;
  justify-content: center;
`;

export const StyledHeader = styled.div`
  height: 80px;
  width: 100%;
  background-color: ${colors.coral};
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
`;

export const MessageContainer = styled.div`
  ${breakpoints.smDown} {
    width: 90%;
    padding-top: 60px;
    padding-bottom: 0px;
  }
  ${breakpoints.smUp} {
    max-width: 800px;
    padding: 60px 20px 0px 20px;
  }
  display: flex;
  flex-direction: column;
`;
